import React, { Component } from 'react';

interface CustomInputProps {
  partner: any;
}

class PartnerLogo extends Component<CustomInputProps> {
  render() {
    function getPartnerUrl(self: any) {
      if (self.props.partner == 1526) {
        return require('../../assets/img/zadig-et-voltaire.png');
      } else if (self.props.partner == 1981) {
        return 'https://www.louispion.fr/skin/frontend/louispion_v2/responsive/images/svg/LP_logo.svg';
      } else if (self.props.partner == 2023) {
        return 'https://octipas-sftp.s3-eu-west-1.amazonaws.com/KENZO/STAGING/images/logo-kenzo-2020.png';
      }
    }

    return <img src={getPartnerUrl(this)} alt=" " style={{ width: '18em' }}></img>;
  }
}
export default PartnerLogo;
